import { articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              编辑推荐的优质内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}